var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isBase)?_c('base-version',{on:{"onFullVersion":_vm.onFullVersion}}):_c('full-version',{attrs:{"companyName":_vm.companyName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }